import { jsx as _jsx } from "react/jsx-runtime";
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { useMemo } from 'react';
import { useDraggableList } from './DraggableListContext';
export const Row = ({ RowComponent, datumId }) => {
    const { attributes, isDragging, listeners, over, setNodeRef, transform, transition, } = useSortable({
        id: datumId,
    });
    const { dataSource, removeDataSourceItem, sortedIds, updateDataSourceByItem, } = useDraggableList();
    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
    };
    const data = useMemo(() => dataSource.find((datum) => datum.id === datumId), [dataSource, datumId]);
    const isHovered = data ? (over === null || over === void 0 ? void 0 : over.id) === data.id : false;
    const isLast = sortedIds[sortedIds.length - 1] === datumId;
    return (_jsx(RowComponent, { data: data, dndSortableProps: { attributes, listeners, setNodeRef, style }, isDragging: isDragging, isHovered: isHovered, isLast: isLast, removeDataSourceItem: removeDataSourceItem, updateDataSourceByItem: updateDataSourceByItem }));
};
//# sourceMappingURL=Row.js.map